var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-card",
    {
      staticClass: "supsis-plan",
      class: {
        "selected-plan":
          !_vm.editableCard &&
          _vm.isActive(_vm.plan, _vm.currentPlansHash[_vm.plan._id]),
        "supsis-plan": true,
      },
    },
    [
      _vm.editableCard
        ? _c("div", { staticClass: "editable-form" }, [
            _c(
              "div",
              { staticClass: "form-button", on: { click: _vm.editPlan } },
              [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v(" edit "),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "form-button delete-button",
                on: { click: _vm.deletePlan },
              },
              [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v(" delete "),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "form-button delete-button",
                on: { click: _vm.visibilityChange },
              },
              [
                _vm.isHidden()
                  ? _c("span", { staticClass: "material-icons" }, [
                      _vm._v(" visibility "),
                    ])
                  : _c("span", { staticClass: "material-icons" }, [
                      _vm._v(" visibility_off "),
                    ]),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "p-card-header" }, [
        _c("div", [
          _c("div", { staticClass: "subtitle top" }, [
            _vm._v(
              "\n                " + _vm._s(_vm.plan.title) + "\n            "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.plan.altTitle) +
                "\n            "
            ),
          ]),
          _vm._v(" "),
          _vm.isGroupPlan
            ? _c("div", { staticClass: "subtitle price setFontPrice" }, [
                _c("div", [_vm._v(" ")]),
                _vm._v(" "),
                _c("div", [
                  _vm.getDiscount(_vm.plan) >
                  _vm.getPrice(_vm.plan, _vm.details, _vm.period)
                    ? _c("div", { staticClass: "discount" }, [_vm._v(" ")])
                    : _vm._e(),
                ]),
              ])
            : _c("div", { staticClass: "subtitle price setFontPrice" }, [
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.getPrice(_vm.plan, _vm.details, _vm.period)) +
                      "₺"
                  ),
                ]),
                _vm._v(" "),
                _c("div", [
                  _vm.getDiscount(_vm.plan) >
                  _vm.getPrice(_vm.plan, _vm.details, _vm.period)
                    ? _c("div", { staticClass: "discount" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.getDiscount(_vm.plan)) +
                            "₺\n                    "
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "p-card-tag" }, [
          _vm.plan.isPopular &&
          !_vm.isActive(_vm.plan, _vm.currentPlansHash[_vm.plan._id])
            ? _c("div", { staticClass: "popular" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("plans.popular")) +
                    "\n            "
                ),
              ])
            : (
                _vm.wizard
                  ? _vm.isSelected
                  : !_vm.editableCard &&
                    _vm.isActive(_vm.plan, _vm.currentPlansHash[_vm.plan._id])
              )
            ? _c("div", { staticClass: "selected-plan-tag" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.isSelected
                        ? _vm.$t("plans.selected")
                        : _vm.$t("plans.currentPlan")
                    ) +
                    "\n            "
                ),
              ])
            : _vm.plan.isTrialPlan
            ? _c("div", { staticClass: "popular" }, [
                _vm._v(_vm._s(_vm.$t("plans.trialPkg"))),
              ])
            : _vm.editableCard
            ? _c("div", { staticClass: "popular" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.plan.siteId
                        ? _vm.$t("plans.specialPlan")
                        : _vm.$t("plans.generalPlan")
                    ) +
                    "\n            "
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "plan-content" },
        [
          _vm.isGroupPlan
            ? _c("div", { staticClass: "p-card-content" }, [
                _c("div", [
                  _c("p", [
                    _c("i", { staticClass: "fa fa-check" }),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("plans.chipPlans")) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.plan.type === "supsis"
                    ? _c("p", [
                        _c("i", { staticClass: "fa fa-check" }),
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("plans.stableAgentCount")) +
                            "\n                "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.plan.type === "instagram"
                    ? _c("p", [
                        _c("i", { staticClass: "fa fa-check" }),
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("plans.stableChannelCount")) +
                            "\n                "
                        ),
                      ])
                    : _vm._e(),
                ]),
              ])
            : _c("div", { staticClass: "p-card-content" }, [
                _vm.plan.features
                  ? _c(
                      "div",
                      _vm._l(Object.keys(_vm.features), function (key) {
                        return _c("CardFeatureText", {
                          key: key,
                          attrs: { value: key, features: _vm.features },
                        })
                      }),
                      1
                    )
                  : _vm._e(),
              ]),
          _vm._v(" "),
          !_vm.isRequireCodes() && !_vm.editableCard
            ? _c(
                "div",
                {
                  staticClass: "subscription-button",
                  class: {
                    disabled: !_vm.isUpgrade().enabled,
                    selected: _vm.isActive(),
                  },
                  on: { click: _vm.onClick },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(this.getButtonText()) +
                      "\n        "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isAdmin && _vm.isRequireCodes() && !_vm.editableCard
            ? _c("CodeInput", {
                attrs: { disabled: _vm.isDisabledCode() },
                on: { confirm: _vm.applyCouponCode },
                model: {
                  value: _vm.couponCode,
                  callback: function ($$v) {
                    _vm.couponCode = $$v
                  },
                  expression: "couponCode",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }